<template>
	
	<div class="row" style="background-color: white;padding-top: 20px;padding-right: 20px;padding-left: 20px;background-color: black;">
		
		<!-- Profile Info and Notifications -->
		<div class="col-md-3 col-sm-3 clearfix">
			<div class="logo">
				<router-link to="/octopus">
					<!-- <img :src="logo()" width="120" alt="" /> -->
                     <b style="color: white;">Marquez Express Inc.</b>
				</router-link>
				
			</div>
		</div>
		
		
	
		<!-- Raw Links -->
		<div class="col-md-9 col-sm-9 clearfix hidden-xs">
			<ul class="user-info pull-right pull-none-xsm">
	
				<!-- Profile Info -->
				<li class="profile-info dropdown"><!-- add class "pull-right" if you want to place this from right -->
					<a href="#" class="dropdown-toggle" data-toggle="dropdown" style="color: white;">
						<img :src="profile()" alt="" class="img-circle" width="44" />
						{{this.$parent.user.name}}

						| <a @click="$root.handleLogout" style="color: white;">Sign out <i class="entypo-logout right"></i></a>
					</a>
					<ul class="dropdown-menu">
						<!-- Reverse Caret -->
						<li class="caret"></li>
						<!-- Profile sub-links -->
						<li><router-link to="/profile/"><i class="fa fa-edit" style="color: white;"></i> Edit profile</router-link></li>
						
					</ul>
				</li>
				
		
			</ul>
			
		</div>
		
		<loader style="position: fixed;z-index: 10000;" v-if="$root.isLoading == true" object="#29166e" color1="#ffffff" color2="#29166e" size="5" speed="2" bg="#343a40" objectbg="#999793" opacity="80" disableScrolling="false" name="circular"></loader>
		<div class="row">
			<div class="horizontal-menu">
    <ul id="main-menu" class="main-menu">
        <li v-for="(item, index) in menu" :class="{'has-sub': item.sub_menus.length > 0}" :key="index">
            
            <a v-if="item.sub_menus.length > 0" style="color:white">
                <i :class="item.icon"></i>
                <span class="title">{{ item.name }}</span>
            </a>
            <router-link :to="item.route" v-else style="color:white">
                <i :class="item.icon"></i>
                <span class="title">{{ item.name }}</span>
            </router-link>

            <!-- Submenú -->
            <ul v-if="item.sub_menus.length > 0" class="submenu">
                <li v-for="(sub, subindex) in item.sub_menus" :key="subindex" :class="{'has-sub': sub.sub_sub_menus?.length > 0}">

                    <a v-if="sub.sub_sub_menus?.length > 0" style="color:white">
                        <i :class="sub.icon"></i>
                        <span class="title">{{ sub.name }}</span>
                    </a>
                    <router-link :to="sub.route" v-else style="color:white">
                        <i :class="sub.icon"></i>
                        <span class="title">{{ sub.name }}</span>
                    </router-link>

                    <!-- Sub-submenú -->
                    <ul v-if="sub.sub_sub_menus?.length > 0" class="sub-submenu">
                        <li v-for="(subSub, subSubIndex) in sub.sub_sub_menus" :key="subSubIndex">
                            <router-link :to="subSub.route" style="color:white">
                                <i :class="subSub.icon"></i>
                                <span class="title">{{ subSub.name }}</span>
                            </router-link>
                        </li>
                    </ul>
                </li>
            </ul>
        </li>
    </ul>
</div>

		</div>
	</div>
	
	
</template>

<script type="text/javascript">
	export default {
		data(){
			return {
				menu:{}
			}
		},

		methods:{
			profile(){
				return ('https://ui-avatars.com/api/?name='+this.$parent.user.name+'&size=256');
			}	,
			getMenus(){
				axios.get(tools.url("/api/admin/menu")).then((response)=>{
			    	this.menu=response.data;
			    	this.menu.sort((a,b)=>{
			    		return a.position-b.position;
			    	});
			    	setTimeout(()=>{
			    		this.mountMenu();
			    	},3000);
			    	
			    }).catch((error)=>{
			        this.error=error.response.data.error;			        
			        this.inPetition=false;
			    });
				
			},
			logo(){
				return window.tools.url('/public/images/logo.png');
			}
		},
		mounted() {
        	this.getMenus();
        }
    }
</script>
<style>
.horizontal-menu {
    width: 98%; /* Ocupar todo el ancho disponible */
    background-color: #29166e;
    display: flex;
    margin-left: 15px;
}

#main-menu {
    display: flex;
    flex-direction: row; /* Alinear elementos en una fila */
    list-style: none;
    padding: 0;
    margin: 0;
    width: 100%;

}

#main-menu > li {
    position: relative;
    padding: 10px 15px;
}

#main-menu > li > a, 
#main-menu > li > router-link {
    text-decoration: none;
    color: white;
    font-size: 16px;
    display: block;
}

/* Submenú */
.submenu {
    display: none;
    position: absolute;
    background-color: #29166e;
    top: 100%;
    left: 0;
    list-style: none;
    padding: 0;
    margin: 0;
    min-width: 200px;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
    z-index: 1000; /* Asegura que el submenú esté sobre otros elementos */
}

#main-menu li:hover > .submenu {
    display: block;
}

/* Sub-submenú */
.sub-submenu {
    display: none;
    position: absolute;
    background-color: #1a0e4f;
    top: 0;
    left: 100%;
    list-style: none;
    padding: 0;
    margin: 0;
    min-width: 180px;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
    z-index: 1000;
}

.submenu li:hover > .sub-submenu {
    display: block;
}

.submenu li {
    padding: 10px;
    position: relative;
}

.submenu li a {
    color: white;
    text-decoration: none;
    display: block;
}

.submenu li:hover {
    background-color: #1a0e4f;
}

</style>